import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppInitService, ServerType } from "./app-init.service";

@Injectable({
  providedIn: "root",
})
export class RestApiService {

  constructor(
    private http: HttpClient,
    private appInitService: AppInitService
  ) { }

  get(serverType: ServerType, serviceName: string, options?: any): Observable<any> {
    return this.http.get<any>(this.getUrl(serverType) + serviceName, options);
  }

  post(serverType: ServerType, serviceName: string, body: any, options?: any): Observable<any> {
    return this.http.post(this.getUrl(serverType) + serviceName, body, options);
  }

  delete(serverType: ServerType, serviceName: string, options?: any): Observable<any> {
    return this.http.delete<any>(this.getUrl(serverType) + serviceName, options);
  }

  getUrl(serverType: ServerType) {
    return this.appInitService.serverList.find(server => server.type == serverType)?.url;
  }
}
